import { EnumJobMatchesFilter, EnumJobMatchesSortingFilter } from "@pages/candidate/JobPage/JobMatchesPage/components/FilterSection";
import api from "../api";
import axios from "../utils/axios.instance";
import handleError from "./handle-error";

interface IGetJobsParams {
  page?: number,
  limit?: number,
  jobStatus?: number
}

export const getJobs = async ({
  page,
  limit,
  jobStatus
}: IGetJobsParams) => {
  try {
    const params = new URLSearchParams()
    if (page) params.append('page', page?.toString())
    if (limit) params.append('limit', limit?.toString())
    if (jobStatus) params.append('jobStatus', jobStatus?.toString())
    const { data } = await axios.post(api.getJobList + `?${params?.toString()}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getJobById = async ({ jobId, candidateId }) => {
  try {
    const { data } = await axios.get(api.getJobDetails + `/${jobId}${candidateId ? `?candidateId=${candidateId}` : ''}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const shareJob = async (payload) => {
  try {
    const { data } = await axios.post(api.shareJob, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const verifyJob = async ({ email, otp }) => {
  try {
    const { data } = await axios.get(api.verifyJob + `/${email}/${otp}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const verifyJobStatus = async ({ email }) => {
  try {
    const { data } = await axios.get(api.verifyJobStatus + `/${email}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const addJob = async (payload) => {
  try {
    const { data } = await axios.post(api.addJob, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const updateJob = async (payload) => {
  try {
    const { data } = await axios.patch(api.updateJob, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const deleteJob = async (jobId) => {
  try {
    const { data } = await axios.delete(api.deleteJob + jobId);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const publishUnpublish = async (jobId, status) => {
  try {
    const { data } = await axios.patch(
      api.publishUnpublish + "/" + jobId + "/" + status
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const applyJob = async (payload) => {
  try {
    const { data } = await axios.post(api.applyJob, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getApplicantList = async (jobId) => {
  try {
    const { data } = await axios.get(api.applicantList + `/${jobId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const jobMessageList = async ({
  receiverId,
  jobApplicationId,
  page = 1,
  limit = 25,
}) => {
  try {
    const params = new URLSearchParams();
    if (page !== undefined) params.append("page", page.toString());
    if (limit !== undefined) params.append("limit", limit.toString());
    const url = params.toString()
      ? `/job/message/lists/${jobApplicationId}/${receiverId}?${params.toString()}`
      : `/job/message/lists/${jobApplicationId}/${receiverId}`;

    const { data } = await axios.get(url);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const jobMesasgesByJobId = async ({ receiverId, jobId }) => {
  try {
    const { data } = await axios.get(
      `/job/message/lists/${receiverId}?jobId=${jobId}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const jobMessage = async (payload) => {
  try {
    const { data } = await axios.post(api.jobMessage, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

interface ICandidateAppliedJobsParams {
  page: number,
  limit: number
}
export const candidateAppliedJobs = async ({
  page,
  limit
}: ICandidateAppliedJobsParams) => {
  try {
    const params = new URLSearchParams()
    if (page) params.append('page', page?.toString())
    if (limit) params.append('limit', limit?.toString())
    const { data } = await axios.get(api.getCandidateAppliedJobs + `?${params?.toString()}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const jobMembersProfile = async () => {
  try {
    const { data } = await axios.get(api.jobMembersProfile);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const jobAddTracker = async (payload) => {
  try {
    const { data } = await axios.post(api.jobAddTracker, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getJobSubmissionQueue = async (jobId: string) => {
  try {
    const { data } = await axios.get(api.jobSubmission + `/${jobId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const removeJobSubmissionQueueItem = async (submissionId: string) => {
  try {
    const { data } = await axios.delete(api.jobSubmission + `/${submissionId}/remove`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const submitJobSubmissionQueue = async (jobId: string) => {
  try {
    const { data } = await axios.post(api.jobSubmissionQueueSubmit(jobId));
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


export const jobGetTracker = async (jobId) => {
  try {
    const { data } = await axios.get(api.jobGetTracker + `/${jobId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const jobUpdateApplicant = async (payload) => {
  try {
    const { data } = await axios.patch(api.jobUpdateApplicant, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const unseenMessageCount = async () => {
  try {
    const { data } = await axios.get(api.unseenMessageCount);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const updateMessageSeen = async (payload) => {
  try {
    const { data } = await axios.patch(api.updateMessageSeen, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

interface ICandidateMatchedJobsQueries {
  page?: number,
  limit?: number,
  searchText?: string,
  type: EnumJobMatchesFilter,
  sortBy: EnumJobMatchesSortingFilter
}

export const candidateMatchedJobs = async ({ page = 1, limit = 25, searchText, type, sortBy }: ICandidateMatchedJobsQueries) => {
  try {
    const params = new URLSearchParams()
    if (page) params.append('page', page?.toString())
    if (limit) params.append('limit', limit?.toString())
    if (type) params.append('type', type?.toString())
    if (searchText) params.append('searchText', searchText?.toString())
    if (sortBy) params.append('sortBy', sortBy?.toString())
    const { data } = await axios.get(api.getCandidateMatchedJobs + '?' + params?.toString());
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const markUnmarkFavoriteMatchedJobs = async (payload: {
  isMarkFavorite: boolean;
  matchId: string;
  tag: string;
}) => {
  try {
    const { data } = await axios.post(api.markUnmarkFavoriteMatchedJobs, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getMatchedJobById = async (jobId) => {
  try {
    const { data } = await axios.get(api.getJobDetails + `/${jobId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getMatchJobSkills = async (jobId) => {
  try {
    const { data } = await axios.get(api.matchJobSkils + `/${jobId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const jobSeen = async (jobId) => {
  try {
    const { data } = await axios.post(api.jobSeen, jobId);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getJobContactMatches = async (jobId) => {
  try {
    const { data } = await axios.get(`${api.contactMatches}/${jobId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const confirmExclusiveRepresentation = async (payload) => {
  try {
    const { data } = await axios.post(
      api.confirmExclusiveRepresentation,
      payload
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

interface IJobListViewByCandidateParams {
  page: number,
  limit: number,
  searchText?: string
}

export const jobListViewByCandidate = async ({
  page = 1,
  limit = 25,
  searchText
}: IJobListViewByCandidateParams) => {
  try {
    const params = new URLSearchParams()
    if (limit) params.append('limit', limit?.toString())
    if (page) params.append('page', page?.toString())
    if (searchText) params.append('searchText', searchText?.toString())
    const { data } = await axios.get(
      api.jobListViewByCandidate + `?${params?.toString()}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

interface IJobListByCompanyParams {
  hiringCompanyId: string,
  page: number,
  limit: number,
  jobStatus?: number | undefined
}
export const jobListByCompany = async ({
  hiringCompanyId,
  page = 1,
  limit = 25,
  jobStatus
}: IJobListByCompanyParams) => {
  try {
    const params = new URLSearchParams()
    if (limit) params.append('limit', limit?.toString())
    if (page) params.append('page', page?.toString())
    if (jobStatus) params.append('jobStatus', jobStatus?.toString())
    const { data } = await axios.get(
      api.jobListByCompany(hiringCompanyId) + `?${params?.toString()}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
